import { isRowInEntityFilter } from './entityValue';

// Header row, then one row per transaction. Rows outside the entity filter are hidden, never dropped,
// so they still reach the save payload.
export const CashFlowRowConfig = (items: any, activeEntities: string[] = []) => [
  {
    largeHeader: true,
    ignoreRowCopy: true,
    className: 'division-bottom-only text-right',
    readOnly: true,
  },
  ...(items || []).map((item: any) => ({
    ...item,
    isDeletableRow: !item?.is_virtual,
    isVisible: isRowInEntityFilter(item, activeEntities),
  })),
];
